import React from 'react';
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import styled from 'styled-components/macro';

import Loading from 'components/Loading';


const Map = ({ className, children, apiKey, ...props }) => (
    <Container className={className}>
        <LoadScript googleMapsApiKey={apiKey} loadingElement={<MapLoading/>}>
            <GoogleMap mapContainerClassName='google-map-container' {...props}>
                {children}
            </GoogleMap>
        </LoadScript>
    </Container>
);


export default Map;


const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    
    .google-map-container {
        position: relative;
        z-index: 1;
        width: 100%;
        height: calc(100% + 25px); // hide google logo
    }
`;

const MapLoading = styled(Loading)`
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    background-color: ${props => props.theme.app_background};
`;
